import apiClient from '@/api/client/api-client';

type GetGiftDataPayload = {
  code: string;
};

export const getGiftData = async ({ code }: GetGiftDataPayload) => {
  const url = `gift/contribute/${code}`;
  return apiClient({ url, method: 'GET' });
};
// Initial contribution creation - returns UUID
type GiftContributePayload = {
  code: string;
  amount: number;
  // Ahead of the backend (DEV-624): the API currently ignores this field.
  privateAmount: boolean;
};

export const giftContribute = async ({ code, ...data }: GiftContributePayload) => {
  const url = `gift/contribute/${code}/contributions`;
  return apiClient({ url, data, method: 'POST' });
};


type GiftTextMessagePayload = {
  code: string;
  uuid: string;

  occasion?: string;
  text: string;
};

// Text message
export const giftTextMessage = async ({
  code,
  uuid,
  ...data
}: GiftTextMessagePayload) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/message/text`;
  return apiClient({ url, data, method: 'POST' });
};

// Media initiation
type giftInitiatePayload = {
  occasion?: string;
  text?: string;
  type: string;
  contentType: string;
  uuid: string;
  code: string;
  sizeBytes?: number;
};

export const giftMediaInitiate = async ({
  code,
  uuid,
  ...data
}: giftInitiatePayload) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/message/media/init`;
  return apiClient({ url, data, method: 'POST' });
};

// Media completion
type GiftMediaCompletePayload = {
  code: string;
  uuid: string;

  /**
   * Which media is being committed. Required for a photo (DEV-636): without
   * it the API takes the audio/video branch and answers
   * 400 "messageId is required".
   */
  type?: string;
  /**
   * Audio and video only — they are messages, and their init hands one back.
   * A photo is not a message and never carries one.
   */
  messageId?: string;
  sizeBytes?: number;
  durationSec?: number;
};

export const giftMediaComplete = async ({
  code,
  uuid,
  ...data
}: GiftMediaCompletePayload) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/message/media/complete`;
  return apiClient({ url, data, method: 'POST' });
};

// Contribution details
type GiftContributionDetailsPayload = {
  code: string;
  uuid: string;

  legalFirstName: string;
  legalLastName: string;
  email: string;
  phone: string;
  relationshipToChild: string;
  nameKnownAs?: string;
  privacyConsent: boolean;
  marketingOptIn: boolean;
};

export const giftContributionDetails = async ({
  code,
  uuid,
  ...data
}: GiftContributionDetailsPayload) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/details`;
  return apiClient({ url, data, method: 'PUT' });
};

type GiftContributorProfilePhotoUploadPayload = {
  code: string;
  uuid: string;
  photo: File;
};

export const giftContributorProfilePhotoUpload = async (
  {
    code,
    uuid,
    photo,
  }: GiftContributorProfilePhotoUploadPayload
) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/profile-photo`;
  return apiClient({ url, data: { photo }, method: 'POST', isFileUpload: true });
};

// Open banking
type OpenBankingPayload = {
  uuid: string;
  code: string;
  data?: Record<string, unknown>;
};
export const openBanking = async ({code, uuid, data={}}: OpenBankingPayload) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/open-banking`;
  return apiClient({ url, data, method: 'POST' });
};

// Get contribution status
export const giftContributionStatus = async (
  uuid: string,
  data: { code: string },
) => {
  const url = `gift/contribute/${data?.code}/contributions/${uuid}/status`;
  return apiClient({ url, method: 'GET' });
};

export const openBankingRestart = async (
  code: string,
  uuid: string,
  data: Record<string, unknown>,
) => {
  const url = `gift/contribute/${code}/contributions/${uuid}/open-banking/restart`;
  return apiClient({ url, data, method: 'POST' });
};


